export default __webpack_public_path__ + "static/media/discussion_icon.c7ec9585.svg";